import React from "react";

import { Menu } from "semantic-ui-react";

import { withRouter } from "react-router-dom";

const isSubpath = (path, root) => {
  return path.substring(0, root.length) === root;
};

const _MenuItem = props => {
  var isActive;
  if (props.exact) {
    isActive = props.location.pathname === props.url;
  } else {
    isActive = isSubpath(props.location.pathname, props.url);
  }
  return (
    <Menu.Item onClick={() => props.history.push(props.url)} active={isActive}>
      {props.children}
    </Menu.Item>
  );
};

const RouteMenuItem = withRouter(_MenuItem);

export default RouteMenuItem;



// WEBPACK FOOTER //
// ./frontend/src/components/RouteMenuItem.js